export default __webpack_public_path__ + "static/media/File-Number-6.1.7a075e4c.pdf";